import { lazy } from 'react';

// ----------------------- ADMIN ROUTES -----------------------
export const AdminDashboard = lazy(() => import('@/pages/admin/dashboard/admin-dashboard'));
export const AdminAdmissions = lazy(() => import('@/pages/admin/admission/admission'));
export const TakeAttendance = lazy(() => import('@/_components/admin/attendance/take-attendance'));
export const AdminAnnouncements = lazy(
  () => import('@/_components/admin/announcement/announcements')
);
export const AdminSoa = lazy(() => import('@/pages/admin/finance/soa/page'));
export const AddSchoolAdmin = lazy(() => import('@/pages/admin/add/add-school-admin'));
export const AddSchoolTeacher = lazy(() => import('@/pages/admin/add/add-school-teacher'));
export const AddSchoolStudent = lazy(() => import('@/pages/admin/add/add-school-student'));
export const AddStudentBulk = lazy(() => import('@/pages/admin/add/bulk/add-student-bulk'));
export const AddTeacherBulk = lazy(() => import('@/pages/admin/add/bulk/add-teacher-bulk'));
export const AddAdminBulk = lazy(() => import('@/pages/admin/add/bulk/add-admin-bulk'));
export const AddStaffBulk = lazy(() => import('@/pages/admin/add/bulk/add-staff-bulk'));

export const AdminSchoolCalendar = lazy(() => import('@/pages/admin/calendar/school-calendar'));

export const AssignClassTeacher = lazy(
  () => import('@/pages/admin/academics/class-teacher/assign-class-teacher')
);
export const PreviousExams = lazy(
  () => import('@/pages/admin/academics/previous-exams/previous-exams')
);
export const AdminWeeklyPlanner = lazy(
  () => import('@/pages/admin/academics/weekly-planner/admin-weekly-planner')
);
export const AdminStandardWeeklyPlanner = lazy(
  () => import('@/pages/admin/academics/weekly-planner/admin-standard-weekly-planner')
);
export const AdminHomeworkPlanner = lazy(
  () => import('@/pages/admin/academics/homework-planner/admin-homework-planner')
);
export const AdminStandardHomeworkPlanner = lazy(
  () => import('@/pages/admin/academics/homework-planner/admin-standard-homework-planner')
);
export const AdminStudentSyllabus = lazy(
  () => import('@/pages/admin/academics/syllabus/admin-student-syllabus')
);
export const AdminStandardSyllabus = lazy(
  () => import('@/pages/admin/academics/syllabus/admin-standard-syllabus')
);
export const AddSubject = lazy(() => import('@/pages/admin/academics/add-subject/add-subject'));
export const AdminTimeTable = lazy(
  () => import('@/pages/admin/academics/time-table/time-table')
);
export const StudentDivisionTransfer = lazy(
  () => import('@/pages/admin/academics/transfer/student-transfer')
);
export const SchoolSetting = lazy(
  () => import('@/pages/admin/academics/school-setting/school-setting')
);

export const StudentPromotion = lazy(
  () => import('@/pages/admin/academics/promotion/student-promotion')
);
export const GradingSystem = lazy(
  () => import('@/pages/admin/academics/grading-system/grading-system')
);
export const AdminReportCard = lazy(
  () => import('@/pages/admin/academics/report-card/admin-report-card')
);
export const DefineRates = lazy(() => import('@/pages/admin/academics/fees/define-rates'));
export const PendingFees = lazy(() => import('@/pages/admin/academics/fees/pending-fees'));

export const FeeStructure = lazy(() => import('@/pages/admin/academics/fees/fee-structure'));
export const CashDeposit = lazy(() => import('@/pages/admin/cash-deposit/cash-deposit'));

export const DisciplineRecords = lazy(
  () => import('@/pages/admin/discipline-records/discipline-records')
);
export const AdminTeacherLeaves = lazy(
  () => import('@/pages/admin/leaves/teacher/admin-teacher-leaves')
);
export const AdminStudentLeaves = lazy(
  () => import('@/pages/admin/leaves/student/admin-student-leaves')
);
export const AdminStaffLeaves = lazy(() => import('@/pages/admin/leaves/staff/admin-staff-leaves'));

export const AdminReports = lazy(() => import('@/pages/admin/reports/reports'));
export const RankingReport = lazy(() => import('@/pages/admin/reports/ranking-report'));
export const DuplicateStudents = lazy(
  () => import('@/pages/admin/duplicates/duplicate-students')
);
export const AdminLibrary = lazy(() => import('@/pages/admin/library/admin-library'));
export const AdminLibraryImport = lazy(() => import('@/pages/admin/library/library-import'));
export const AdminInventory = lazy(() => import('@/pages/admin/inventory/admin-inventory'));

// ----------------------- TEACHER ROUTES -----------------------
export const TeacherDashboard = lazy(() => import('@/pages/teacher/dashboard/teacher-dashboard'));
export const TeacherTakeAttendance = lazy(
  () => import('@/pages/teacher/attendance/take-attendance')
);
export const UpdateAttendance = lazy(() => import('@/pages/teacher/attendance/update-attendance'));
export const AttendanceSheet = lazy(() => import('@/pages/teacher/attendance/attendance-sheet'));
export const TeacherSchoolCalendar = lazy(() => import('@/pages/teacher/calendar/school-calendar'));
export const MyStudents = lazy(() => import('@/pages/teacher/students/my-students'));
export const TeacherLeaveApplication = lazy(
  () => import('@/pages/teacher/leave-application/leave-application')
);
export const TeacherAnnouncements = lazy(
  () => import('@/pages/teacher/announcements/teacher-announcements')
);
export const StudentReportCards = lazy(
  () => import('@/pages/teacher/report-cards/student-report-cards')
);

export const TeacherWeeklyPlanner = lazy(
  () => import('@/pages/teacher/weekly-planner/teacher-weekly-planner')
);

// TEACHER SUBJECTS ROUTES
export const TeacherSubjectsPage = lazy(() => import('@/pages/teacher/subjects/page'));
export const SubjectHomePage = lazy(() => import('@/pages/teacher/subjects/home/subject-home'));
export const TeacherStudentsInSubjects = lazy(
  () => import('@/pages/teacher/subjects/students/students-in-subjects')
);
export const TeacherWeightage = lazy(
  () => import('@/pages/teacher/subjects/grading/weightage/teacher-weightage')
);
export const AddFinalGrades = lazy(
  () => import('@/pages/teacher/subjects/grading/add-grades/add-final-grades')
);
export const TeacherSyllabus = lazy(
  () => import('@/pages/teacher/subjects/syllabus/teacher-syllabus')
);
export const TeacherModules = lazy(
  () => import('@/pages/teacher/subjects/modules/teacher-modules')
);
export const TeacherSubjectAnnouncements = lazy(
  () => import('@/pages/teacher/subjects/announcements/teacher-subject-announcements')
);
// TEACHER ASSESSMENTS ROUTES
export const TeacherAssessments = lazy(
  () => import('@/pages/teacher/subjects/assessments/teacher-assessments')
);
export const TeacherCreateAssessment = lazy(
  () => import('@/pages/teacher/subjects/assessments/create/teacher-create-assessment')
);
export const TeacherOpenAssessment = lazy(
  () => import('@/pages/teacher/subjects/assessments/open/teacher-open-assessment')
);
export const TeacherGradeAssessments = lazy(
  () => import('@/pages/teacher/subjects/assessments/grade/teacher-grade-assessments')
);

// speed grading
export const SpeedGradingView = lazy(
  () => import('@/_components/teacher/subject/assessments/grade/speed-grading-view')
);

export const EnterMarks = lazy(() => import('@/pages/teacher/enter-marks/enter-marks'));
export const ExamDetails = lazy(() => import('@/pages/teacher/enter-marks/exam-details'));
export const EnterMarksInExam = lazy(
  () => import('@/pages/teacher/enter-marks/enter-marks-in-exam')
);

export const StudentDashboard = lazy(() => import('@/pages/student/dashboard/student-dashboard'));

// Shared/Common Routes
export const TempPage = lazy(() => import('@/components/temp-page'));
export const UserProfile = lazy(() => import('@/pages/admin/profile/user-profile'));
export const AdminProfile = lazy(() => import('@/pages/admin/profile/admin-profile'));
export const AdminDebug = lazy(() => import('@/pages/admin/debug/admin-debug'));
export const TeacherProfile = lazy(() => import('@/pages/teacher/profile/teacher-profile'));

// ----------------------- STUDENT ROUTES -----------------------

export const StudentViewAttendance = lazy(
  () => import('@/pages/student/attendance/view-attendance')
);

export const StudentPreviousExams = lazy(
  () => import('@/pages/student/previous-exams/student-previous-exams')
);
export const StudentLeaves = lazy(() => import('@/pages/student/leaves/student-leaves'));
export const StudentSubjects = lazy(() => import('@/pages/student/subject/student-subjects'));
export const StudentAnnouncements = lazy(
  () => import('@/pages/student/announcements/student-announcements')
);

export const StudentSoa = lazy(() => import('@/pages/student/fees/student-soa'));
export const PaidFees = lazy(() => import('@/_components/student/fees/paid-fees'));

export const StudentFinalGrades = lazy(() => import('@/pages/student/grades/student-final-grades'));
export const StudentReportCard = lazy(() => import('@/pages/student/grades/student-report-card'));

export const StudentProfile = lazy(() => import('@/pages/student/profile/student-profile'));
export const StudentCalendar = lazy(() => import('@/pages/student/calendar/student-calendar'));

// ----------------------- STUDENT SUBJECT ROUTES -----------------------
export const StudentSubjectHome = lazy(
  () => import('@/pages/student/subject/home/student-subject-home')
);
export const StudentPeople = lazy(() => import('@/pages/student/subject/people/student-people'));
export const StudentSyllabus = lazy(
  () => import('@/pages/student/subject/syllabus/student-syllabus')
);
export const StudentModules = lazy(() => import('@/pages/student/subject/modules/student-modules'));
export const StudentAssessments = lazy(
  () => import('@/pages/student/subject/assessments/student-assessments')
);
export const StudentOpenAssessment = lazy(
  () => import('@/pages/student/subject/assessments/student-open-assessment')
);
export const StudentSubjectAnnouncements = lazy(
  () => import('@/pages/student/subject/announcements/student-subject-announcements')
);

export const StudentSubjectGrades = lazy(
  () => import('@/pages/student/subject/grades/student-subject-grades')
);

export const StudentQuiz = lazy(() => import('@/pages/student/subject/quiz/student-quiz'));

export const StudentTeacherMessages = lazy(
  () => import('@/pages/student/student-teacher-messages')
);

// New Teacher Action Components (Admin Perspective)
export const AdminTeacherTakeAttendance = lazy(
  () => import('@/pages/admin/teacher/admin-teacher-take-attendance')
);
export const AdminTeacherAttendanceSheet = lazy(
  () => import('@/pages/admin/teacher/admin-teacher-attendance-sheet')
);
export const AdminTeacherUpdateAttendance = lazy(
  () => import('@/pages/admin/teacher/admin-teacher-update-attendance')
);
export const AdminTeacherPayroll = lazy(
  () => import('@/pages/admin/teacher/admin-teacher-payroll')
);

export const TelephoneRecords = lazy(
  () => import('@/pages/teacher/subjects/students/telephone-records')
);
export const MessageParent = lazy(() => import('@/pages/teacher/subjects/students/message-parent'));
export const DisciplineRecord = lazy(
  () => import('@/pages/teacher/subjects/students/discipline-record')
);
export const AnecdotalRecord = lazy(
  () => import('@/pages/teacher/subjects/students/anecdotal-record')
);
